import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import * as customPropTypes from '@/custom-prop-types';
import { SearchResultsCardGeneric } from '@/design-system/atoms/SearchResultsCards/SearchResultsCardGeneric';
import { SearchResultsCardLocation } from '@/design-system/atoms/SearchResultsCards/SearchResultsCardLocation';
import { SearchResultsCardTeam } from '@/design-system/atoms/SearchResultsCards/SearchResultsCardTeam';

import styles from './SearchRecommendedCard.module.scss';

/**
 * The SearchRecommendedCard component displays a recommended search result.
 * @param {object} props - The component props
 * @param {string} props.className - Additional class name
 * @param {object} props.result - The search result object
 * @returns {React.Component} The search recommended card component
 */
const SearchRecommendedCard = ({ className, result, analytics, ...props }) => {
    const badge = {
        type: 'recommended',
        label: 'Recommended',
    };

    /**
     * Get the proper search card component for the result type.
     * @param {string} type
     * @returns {React.Component} The proper search card for this result type
     */
    const getComponent = (type) => {
        switch (type) {
            case 'location':
                return SearchResultsCardLocation;
            case 'provider':
                return SearchResultsCardTeam;
            default:
                return SearchResultsCardGeneric;
        }
    };

    const Component = getComponent(result.type);

    return (
        <div className={classnames(styles['search-recommended-card'], className)} {...props}>
            <Component
                {...result}
                badge={badge}
                className={styles['search-recommended-card__Wrapper']}
                analytics={analytics}
            />
        </div>
    );
};

SearchRecommendedCard.propTypes = {
    className: PropTypes.string,
    result: PropTypes.object,
    analytics: customPropTypes.analyticsPropType,
};

SearchRecommendedCard.defaultProps = {};

export default SearchRecommendedCard;
